import Loadable from '../../components/loadable';

const ContactMobileApp = Loadable({
  loader: () => import('../../pages/contacts/mobile_app'),
  type: 'block',
});

angular.module('gym').value('ContactMobileApp', ContactMobileApp);
